import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
	icons: {
		defaultSet: "mdi", // This is already the default value - only for display purposes
	},
});
